import { Box, Button, Grid, Typography } from '@mui/material';
import stepsIcon from 'img/steps_icon.png';
import { useSelector } from 'react-redux';
import { isEmptyObj } from 'utils/HelperFunctions';
import SectionHeaderImageIcon from '../SectionHeaderImageIcon';
import PerDayTotalInMonth from './PerDayTotalInMonth';
import PerHourTotalInDay from './PerHourTotalInDay';
import PerWeekAvgInMonth from './PerWeekAvgInMonth';
import { StatsLabels } from 'locale/es';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useState } from 'react';
import CustomDialog from 'components/Dialogs/MasterDialog';
import Dashboard from '..';
import ExportForm from '../ExportHealthData/ExportDialog';
import { AppColors } from 'resources/AppColors';

const StepsStats = () => {
  const [showExportModal, setShowExportModal] = useState(false);

  const patientId = useSelector(({ patient }) => patient.id);

  const handleShowExportModal = () => {
    setShowExportModal(!showExportModal);
  };

  return (
    <>
      {!isEmptyObj(patientId) && (
        <Grid container justifyContent='center' spacing={2}>
          <SectionHeaderImageIcon
            icon={stepsIcon}
            sectionTitle={StatsLabels.STEPS}
          />
          <Box sx={{ '& button': { m: 1 }, mt: -7, ml: 110 }}>
            <Button
              sx={{ bgcolor: AppColors.WHITE, borderColor: AppColors.PRIMARY }}
              variant='outlined'
              type='button'
              onClick={handleShowExportModal}
              size='small'>
              <FileDownloadIcon sx={{ color: AppColors.PRIMARY }} />
              <Typography variant='body_card' sx={{ color: AppColors.PRIMARY }}>
                Export
              </Typography>
            </Button>
          </Box>
          <Grid item>
            <PerDayTotalInMonth />
          </Grid>
          <Grid item>
            <PerWeekAvgInMonth />
          </Grid>
          <Grid item>
            <PerHourTotalInDay />
          </Grid>
        </Grid>
      )}
      <CustomDialog
        title={Dashboard.EXPORT}
        show={showExportModal}
        handleShow={handleShowExportModal}>
        <ExportForm setShowModal={setShowExportModal} />
      </CustomDialog>
    </>
  );
};

export default StepsStats;
